<template>
  <div>
		<div class="result-tag">
			膳食能量评估：<span :class="[`l${result.level}`]"> {{ getLevel }} </span>
		</div>
		<div class="result-tag">
			膳食结构与评估：<span :class="[`t${result.other.foodStructureLevel}`]">{{ getFoodStructure }}</span>
		</div>

		<h4>每日食物营养成分和摄入量</h4>
		<table>
			<tr>
				<th width="100">食物类别</th>
				<th>主要营养成分</th>
				<th>中国居民膳食指南推荐每日摄入量</th>
			</tr>
			<tr v-for="item in Object.keys(result.other.onceExample)" :key="item">
				<td>{{ result.other.onceExample[item].name }}</td>
				<td>{{ result.other.onceExample[item].nutritious }}</td>
				<td>{{ result.other.onceExample[item].value }}</td>
			</tr>
		</table>

		<h4>每日摄入总热量</h4>
		<div><chart v-if="chartOptions.series[0].data" :options="chartOptions"></chart></div>

		<h4>个人膳食均衡性评价结果</h4>
		<div><chart  v-if="chartOptions2.series[0].data" :options="chartOptions2"></chart></div>

		<h4>膳食管理建议</h4>
		<div>
			<p style="line-height:1.8em; color: #888; text-indent:2em;">{{ result?.other?.suggest }}</p>
		</div>
  </div>

</template>

<script>
import {Chart} from 'highcharts-vue';
import More from 'highcharts/highcharts-more';
import Highcharts from 'highcharts';

More(Highcharts);

export default {  
	components: {Chart},
	props: {
		result: Object
	},
	computed: {
		getLevel() {
			let value = Object.keys(this.result.levelModel).find(k => {
				return this.result.levelModel[k] == this.result.level;
			});
			return value;
		},
		getFoodStructure() {
			let value = Object.keys(this.result.other.foodStructureModel).find(k => {
				return this.result.other.foodStructureModel[k] == this.result.other.foodStructureLevel;
			});
			return value;
		},
	},
	// watch: {
	// 	visible() {
	// 		if (this.visible) {
	// 			this.filter.type = this.type;
	// 			this.loadList();
	// 		}
	// 	}
	// },	
	data(){
		return {
			chartOptions: {
				chart: { 
					type: 'gauge', 
					// spacingBottom: 0,
					spacing: [0,0,0,0],
					height: 300,
				},
        title: null,
        pane: {
					center: ['50%', '68%'],
					startAngle: -90,//起始度数
					endAngle: 90,//结束度数
					size: '120%',//图表大小
					background: {
						backgroundColor: null,
						innerRadius: '0%',//内径大小
						outerRadius: '0%',//外径大小
						shape: 'arc'//面板显示的范围是从坐标轴的最小值到最大值
					}
        },
        tooltip: {
					enabled: false
        },
        // the value axis
        yAxis: {
					min: 800,//最小值
					max: 4000,//最大值
					minorTickInterval: null,//次刻度线
					tickAmount:9,//刻度数量
					tickLength:10,
					tickColor: '#FFF',
					plotBands: [{
						from: 800,
						to: 1800,
						color: '#DDDF0D' // yellow
					}, {
						from: 1800,//返回值里的推荐低值
						to: 2200,//返回值里的推荐高值
						color: '#55BF3B' // green
					}, {
						from: 2200,
						to: 4000,
						color: '#DF5353' // red
					}]
        },
        series: [{
					name: '每日摄入总热量',
					data: undefined,
					dataLabels:{
						color:'#699CE4',
						enabled:true,
						style:{ 'fontSize':'25px' },
						format: undefined
					},
					tooltip: {valueSuffix: 'kcal'}
        }],
        plotOptions: {
					gauge: {
						dataLabels: {
							borderWidth: 0,
							useHTML: true
						}
					}
        },
        exporting:null,
        credits: { enabled: false }
			},
			chartOptions2: {
				chart: {
					type: 'column',
					inverted: true
				},
				title: null,
				xAxis: { categories: undefined },
				yAxis: {
					title: {
						useHTML: true,
						margin: 20,
						text: '<div style="font-size: 16px;"><span style="margin: 0 126px;">摄入不足</span><span style="margin: 0 126px;">摄入过盛</span></div>',
					},
					min: -12,
					max: 12,
				},
				// tooltip: {
				// 	valueSuffix: '°C'
				// },
				plotOptions: {
					column: {
						dataLabels: {
							enabled: true,
							// format: '{y}°C'
						}
					}
				},
				legend: { enabled: false },
				series: [{
					name: '数值',
					data: undefined,
				}],
				credits: { enabled: false }				
			}
		}
	},
	created() {
		let { gauge, foodTree } = this.result.other;
		
		this.chartOptions.yAxis.min = gauge.min;
		this.chartOptions.yAxis.max = gauge.max;
		this.chartOptions.yAxis.plotBands[0].from = gauge.min;
		this.chartOptions.yAxis.plotBands[0].to = gauge.greenLower;

		this.chartOptions.yAxis.plotBands[1].from = gauge.greenLower;
		this.chartOptions.yAxis.plotBands[1].to = gauge.greenUpper;

		this.chartOptions.yAxis.plotBands[2].from = gauge.greenUpper;
		this.chartOptions.yAxis.plotBands[2].to = gauge.max;
		this.chartOptions.series[0].data = gauge.calorieSum < 700 ? [700] : [gauge.calorieSum];
		this.chartOptions.series[0].dataLabels.format = `<div style="text-align:center"><span style="font-size:12px">当前每日摄入总热量：</span><span style="font-size:25px">${gauge.calorieSum}</span>&nbsp;<span style="font-size:12px">kcal</span><br/><span style="font-size:12px;color:#AFAFAF">推荐热量：${gauge.greenLower}&nbsp;kcal~${gauge.greenUpper}&nbsp;kcal</span></div>`

		const labels = [];
		const datas = [];
		foodTree.forEach(item => {
			labels.push(item.name);
			datas.push(item.score)
		})
		this.chartOptions2.xAxis.categories = labels;
		this.chartOptions2.series[0].data = datas;
	},
	methods: {
		getValue(list) {
			if (!list || list.length === 0) {
				return '无';
			}
			let value = list?.map(item => {
				return this.result.other.historyValuesModel[item];
			});
			return value.join(',');
		}
	}
}
</script>

<style lang="less" scoped>
// @import './template.less';	

.result-tag {
	margin-bottom: 10px;
	font-size: 20px;
	.t1 { color: #7ec050;}
	.t2 { color: #dca550;}
	.t3 { color: #e47470;}
	.l1 { color: #dca550;}
	.l2 { color: #7ec050;}
	.l3 { color: #e47470;}
}
</style>
